import { statusColorConfig, statusConfig } from './taskConfig';

const STATUS_NAME_MAP = {
    'en resvision': 'En revisión',
    'en revision': 'En revisión',
};

const normalizeActivityStatusName = (name) => {
    const key = (name || '').normalize('NFD').replace(/\p{Mn}/gu, '').toLowerCase();
    return STATUS_NAME_MAP[key] || name || 'Pendiente';
};

export const getComputedActivityStatus = (breach) => {
    const rawName = breach.activity_status?.name;
    const statusName = normalizeActivityStatusName(rawName);
    if (statusName === 'Pendiente' && breach.breach_date) {
        const breachDate = new Date(breach.breach_date);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        breachDate.setHours(0, 0, 0, 0);
        if (breachDate < today) return 'Expirado';
    }
    return statusName;
};

const MAX_TITLE_LENGTH = 60;

const truncateTitle = (text) => {
    if (!text) return 'Incumplimiento';
    return text.length > MAX_TITLE_LENGTH ? `${text.slice(0, MAX_TITLE_LENGTH)}...` : text;
};

export const convertBreachesToCalendarEvents = (breaches) => {
    return breaches.map(breach => {
        const computedStatus = getComputedActivityStatus(breach);
        const color = statusColorConfig[computedStatus] || '#3174ad';
        return {
            id: breach._id,
            title: truncateTitle(breach.description),
            start: breach.breach_date ? new Date(breach.breach_date).toISOString().split('T')[0] : undefined,
            backgroundColor: color,
            borderColor: color,
            textColor: '#ffffff',
            extendedProps: {
                originalBreach: breach,
                computedStatus,
                mantineColor: statusConfig[computedStatus]?.color || 'gray',
            },
        };
    });
};

export const filterBreachesByStatus = (breaches, filterType) => {
    if (filterType === 'all') return breaches;
    return breaches.filter(b => getComputedActivityStatus(b) === filterType);
};

export const groupBreachesByStatus = (breaches) => {
    const groups = {};
    breaches.forEach(breach => {
        const status = getComputedActivityStatus(breach);
        if (!groups[status]) groups[status] = [];
        groups[status].push(breach);
    });
    return groups;
};